import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"1.414\" id=\"download\"><path d=\"M20.25,23l-16.5,0c-1.518,0 -2.75,-1.204 -2.75,-2.681l0,-2.68l2.75,0l0,2.68l16.5,0l0,-2.68l2.75,0l0,2.68c0,1.477 -1.232,2.681 -2.75,2.681Zm-6.875,-22l0,12.848l4.528,-4.413l1.944,1.895l-7.847,7.649l-7.847,-7.649l1.944,-1.895l4.528,4.413l0,-12.848l2.75,0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol